import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CommentingState, featureKey } from '../state';

export const selectCommentingFeature = createFeatureSelector<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  CommentingState
>(featureKey);

export const selectThreadState = createSelector(selectCommentingFeature, (state) => state.threadState);
export const selectCommentingState = createSelector(selectCommentingFeature, (state) => state.commentState);
